import React, { ReactElement } from 'react';

import Link from '../components/Link/link';
import { LinkProps } from '../components/Link/link.types';

// If LinkProps exist wrap the component in a link otherwise just return it
const wrapLink: Function = (component: ReactElement, linkProps: LinkProps): ReactElement => {
  if (linkProps) {
    return (
      <Link { ...linkProps }>
        { component }
      </Link>
    );
  }

  return component;
};

export default wrapLink;
